import { useHistory } from "react-router-dom";

import { ROUTES } from "@pulsemarket/constants";
import SvgIcon from "components/ui/SvgIcon";
import { useGetRegulations } from "hooks/queries/regulationHooks";
import {
  MenuItemGroup,
  SideMenuItemName,
  SideMenuItemProps,
  SubMenuItemProps,
} from "layout/SideMenu/SideMenu";

import styles from "./SideMenuStyles";

function useGetRegulationMenuItem({
  isOpen,
}: {
  isOpen: boolean;
}): SideMenuItemProps {
  const history = useHistory();
  const { data: regulations } = useGetRegulations();

  const regulationMenuItems: SubMenuItemProps["items"] = (
    regulations || []
  )?.map((regulation) => ({
    label: regulation.name,
    onClick: () => {
      const modules = regulation.modules.map((m) => ({
        order: m.order,
        type: "module",
      }));

      const folders = regulation.folders.map((f) => ({
        order: f.order,
        type: "folder",
      }));

      const firstModuleOrFolder = modules
        .concat(folders)
        .sort((a, b) => a.order - b.order)[0];

      if (firstModuleOrFolder.type === "module") {
        history.push(
          `${
            ROUTES.REGULATIONS({ regulation })[
              regulation.modules.find(
                (m) => m.order === firstModuleOrFolder.order
              )!.type
            ]
          }`
        );
      } else {
        history.push(
          `${ROUTES.REGULATIONS({ regulation }).Folder(
            regulation.folders.find(
              (f) => f.order === firstModuleOrFolder.order
            )!.url
          )}`
        );
      }
    },
  }));

  return {
    group: MenuItemGroup.Resources,
    label: SideMenuItemName.Regulations,
    showLabel: isOpen,
    icon: (
      <SvgIcon
        src="/icons/certifications_icon.svg"
        className={styles.itemIconClass}
      />
    ),
    onClick: () => {},
    subMenu: {
      title: "Regulations and Frameworks",
      items: regulationMenuItems,
    },
  };
}

export default useGetRegulationMenuItem;
